import { render, staticRenderFns } from "./Create-Project.vue?vue&type=template&id=26f24bb2"
import script from "./Create-Project.vue?vue&type=script&lang=js"
export * from "./Create-Project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports